import { IPlatformBIOptions, BI } from './BI';

export interface IPlatformEssentialsOptions {
  bi: IPlatformBIOptions;
}
export class Essentials {
  public bi: BI;

  constructor(options: IPlatformEssentialsOptions) {
    this.bi = new BI(options.bi);
  }
}
